export const sortArrayByField = (
  array: Array<Record<string, any>>,
  field: string,
) => {
  // Create a shallow copy of the array to avoid mutating the original array
  const arrayCopy = [...array];

  return arrayCopy.sort((a, b) => {
    if (a[field] > b[field]) return 1;
    if (a[field] < b[field]) return -1;
    return 0;
  });
};
